module.exports = __webpack_public_path__ + "static/media/Kanel.d85f3e70.PNG";